import Vue from 'vue';
import Vuex from 'vuex';

import authModule from './auth-module';
import adminModule from './admin-module';
import lawModule from './law-module';
import categoryModule from './category-module';
import appModule from './app-module';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
  },
  modules: {
    app: appModule,
    admin: adminModule,
    auth: authModule,
    category: categoryModule,
    law: lawModule,
  },
  getters: {
  },
});
